var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aha-ribbon"},[_c('aha-icon',{staticClass:"aha-ribbon--icon",attrs:{"name":"ribbon-star","viewBox":"0 0 20 20","maintainColor":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }